<template>
<main>
    <section id="kontakt" class="blue-box">
      <div class="flex-group">
        <!-- <div class="content-container"> -->
          <div class="text">
            <h2>So erreichst du mich</h2>
            <p>
              <b>Du möchtest gerne mit mir arbeiten, dann lass uns deine persönliche Ausgangssituation besprechen!</b>
            </p>
            <p>Schreib mir am besten eine Nachricht und hinterlasse mir deine Telefonnummer. Ich melde mich so rasch wie möglich, um
              einen Termin für dein Erstgespräch zu vereinbaren.
              </p>

              <p>Mobil: <a href="tel:+436503614224">0650 / 36 14 224</a></p>
              <p>Email: <a href="mailto:info@pferdeverstand.at?subject=Anfrage%20Pferdeverstand.at">info@pferdeverstand.at</a></p>
            
          </div>
      
          <div>
            <img src="../assets/img/kontakt/kontakt.png" alt="">
          </div>
        <!-- </div> -->
      </div>
    </section>

  </main>

</template>

<script>
export default {
  name: "Kontakt", //this is the name of the component
  
  mounted () {
    // From testing, without a brief timeout, it won't work.
    if (this.$route.hash) {
      setTimeout(() => this.scrollTo(this.$route.hash), 1)
    }
  },
  created() {
    // Watch URL changes Hashs - scrollTo
    this.$watch(
      () => this.$route.hash,
      () => {
        setTimeout(() => this.scrollTo(this.$route.hash), 1)
      }
    )
  },
  methods: {
    scrollTo: function (hashtag) {
      setTimeout(() => { location.href = hashtag }, 1)
    },

    scrollToAnchorPoint(refName) {
        const el = this.$refs[refName]
        el.scrollIntoView({ behavior: 'smooth'})
    }
  
  },
  metaInfo() {
      return { 
          title: "Kontaktdaten Pferdeverstand.at - Sabine D&ouml;br&ouml;ssy",
          meta: [
              { name: 'description', content: 'Pferdeverstand.at - Training und Gesundheit für Reiter und Pferd' },
              { property: 'og:title', content: "Pferdeverstand.at - für alle, die mit ihrem Pferd weiterkommen wollen."},
              { property: 'og:description', content: 'Training und Gesundheit für Reiter und Pferd'},
              { property: 'og:image', content: '../assets/img/og/pferdeverstand-logo.png'},
              { property: 'og:url', content: 'www.pferdeverstand.at'}

          ]
      }
  }
};

// TODO: meta
</script>


<style></style>



// WEBPACK FOOTER //
// src/components/Kontakt.vue